import { render, staticRenderFns } from "./AccessItem.vue?vue&type=template&id=66fead1b&scoped=true&"
import script from "./AccessItem.vue?vue&type=script&lang=js&"
export * from "./AccessItem.vue?vue&type=script&lang=js&"
import style0 from "./AccessItem.vue?vue&type=style&index=0&id=66fead1b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fead1b",
  null
  
)

export default component.exports